import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ArrowForwardSharpIcon from "@mui/icons-material/ArrowForwardSharp";
import { Button } from "@mui/material";
import future1 from "../../assets/Landing/future/future1.png";
import future2 from "../../assets/Landing/future/future2.png";
import future3 from "../../assets/Landing/future/future3.png";

const visionTestimonials = [
  {
    name: "Our partners",
    testimonial:
      "RESELTECH has carried out a wide range of technical exchanges and cooperation in Africa, the Middle East, South America and other blocks, and has been widely recognized by users and continuous orders!",
    img: future1,
  },
  {
    name: "our team",
    testimonial:
      "RESELTECH research and development team includes water control specialists, Fluid mechanic specialists, aerodynamics specialists, reservoir engineers, mechanical engineers, materials engineers and completion engineers",
    img: future2,
  },
  {
    name: "our employees",
    testimonial:
      "RESELTECH has a rigorous, efficient and professional technical service team, which includes technical consultation, solution design, downhole tool customization, on-site technical services and evaluation of oil increase and water control effect",
    img: future3,
  },
];

export default function Future() {
  return (
    <Box
      id="testimonials"
      sx={{
        backgroundColor: "#f9f9f9",
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        padding: "1%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "90%" },
          textAlign: { xs: "center", sm: "center", md: "center" },
        }}
      >
        <Typography sx={{ fontSize: "41px" }}>
          LET'S WORK TOGETHER FOR A BETTER FUTURE
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {visionTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: "flex" }}>
            <Box
              sx={{
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 12 },
                p: 1,
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  pr: 2,
                  fontSize: "40px",
                }}
              >
                <img src={testimonial.img} alt="Future" />
                <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
                <b style={{ fontSize: "24px" }}>{testimonial.name}</b>
                </Box>
                <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
                
                <Typography>{testimonial.testimonial}</Typography>
                </Box>
                
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
            <Button
              variant="contained"
              endIcon={<ArrowForwardSharpIcon />}
              sx={{ width: "130px" }}
            >
              More
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
